import React from 'react';
import { ReactComponent as Arrow } from 'Icons/ArrowOutline.svg';
import { ReactComponent as Tick } from 'Icons/status-tick.svg';

const StatusBar = [
    {id: 1, name: 'RFQ Details', subName: 'Enter RFQ Details'}, 
    {id: 2, name: 'Trip Details', subName: 'Enter Trip Details'},
    {id: 3, name: 'Preview and Submit', subName: 'Preview all the entered Details and Submit'}
]

const RFQStatusBar = (props) => {
    return (
        <div className='RFQStatusbar'>
            <div className='flex flex-between'>
                   {StatusBar.map((el, index) => 
                   (<div className='flex wt-250'>
                        <div className='flex'>
                            {props.activeView > (index + 1) ? 
                                <div className='indexBlock mt-5 green-bg'><Tick /></div> : 
                                <div className='indexBlock mt-5'>
                                    {index + 1}
                                </div>}
                            <div className='ml-10'>
                                <div className='statuslabel'>{el.name}</div>
                                <div className='statusSublabel'>{el.subName}</div>
                            </div>
                        </div>
                        {(StatusBar.length !== (index + 1)) && <div className='statusArrow mt-5 ml-50'><Arrow fill="#DAE0F5"/></div>}
                    </div>))}
            </div>
        </div>
    )
}

export default RFQStatusBar